class FilterLogger extends HTMLElement {
connectedCallback() {
    this.logAndToggleFilters();

    this.addEventListener("change", (event) => {
    this.logAndToggleFilters();
    });

    this.addEventListener("click", (event) => {
    this.logAndToggleFilters();
    });

    const observer = new MutationObserver(() => {
    this.logAndToggleFilters();
    });

    observer.observe(this, { childList: true, subtree: true });
}

logAndToggleFilters() {
    const filters = document.querySelectorAll(".js-filter");

    // Step 1: Store selected options
    const optionMap = {};
    const selectedOptions = new Set();
    filters.forEach((filter) => {
    const options = filter.querySelectorAll("[data-filter-option] input[type='checkbox']");
    options.forEach((input) => {
        const optionLabel = input.closest("[data-filter-option]")?.getAttribute("data-filter-option")?.toLowerCase();
        if (optionLabel) {
        optionMap[optionLabel] = true;
        if (input.checked) selectedOptions.add(optionLabel);
        }
    });
    });

    // Get collection handle and title
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    const collectionHandle = pathParts.includes("collections") ? pathParts[pathParts.indexOf("collections") + 1] : null;
    const collectionTitle = document.getElementById("FacetsWrapperDesktop")?.dataset.collectionTitle?.toLowerCase();

    // Step 2: Toggle filters based on selected options, collection handle, or collection title
    const revealConditions = {
    dimensions: ["canvases", "photos"],
    "flex size": ["headwear"],
    "fitted size": ["headwear"],
    size: ["jersey", "signed jersey", "unsigned jersey", "apparel", "mens"],
    "women's size": ["jersey", "signed jersey", "unsigned jersey", "apparel", "womens"],
    "youth size": ["jersey", "signed jersey", "unsigned jersey", "apparel", "youth"],
    memorabilia: ["oilers fan cave", "memorabilia"],
    novelty: ["oilers fan accessories", "novelty"]
    };

    const forceHiddenCategories = {
    "oilers fan cave": ["team"],
    "oilers fan accessories": ["team"],
    "oilers fan gear": ["team"]
    };

    filters.forEach((filter) => {
    const category = filter.getAttribute("data-filter-category")?.toLowerCase();
    if (!category) return;

    const shouldForceHide =
        collectionTitle &&
        forceHiddenCategories[collectionTitle] &&
        forceHiddenCategories[collectionTitle].includes(category);

    if (shouldForceHide) {
        console.log(`Force-hiding category: ${category} on ${collectionTitle}`);
        filter.style.display = "none";
        return;
    }

    if (revealConditions[category]) {
        const triggers = revealConditions[category];
        const showBecauseSelected = [...selectedOptions].some((opt) => triggers.includes(opt));
        const showBecauseCollectionHandle = collectionHandle && triggers.includes(collectionHandle.toLowerCase());
        const showBecauseCollectionTitle = collectionTitle && triggers.includes(collectionTitle);

        if (showBecauseSelected || showBecauseCollectionHandle || showBecauseCollectionTitle) {
        filter.style.display = "";
        } else {
        filter.style.display = "none";
        }

        return;
    }

    // Default logic
    if (category && optionMap[category]) {
        if (selectedOptions.has(category)) {
        filter.style.display = "";
        } else {
        filter.style.display = "none";
        }
    }
    });

    // Step 3: Move department to top
    const wrapper = document.getElementById("FacetsWrapperDesktop");
    const anchor = document.getElementById("custom-filters-anchor");
    if (wrapper && anchor) {
    const departmentFilter = wrapper.querySelector('[data-index="1"]');
    if (departmentFilter && anchor.nextSibling !== departmentFilter) {
        wrapper.insertBefore(departmentFilter, anchor.nextSibling);
    }
    }
}
}

customElements.define("facet-advanced-filters", FilterLogger);
